require('../../modules/es6.symbol');
module.exports = require('../../modules/$.core').Symbol['for'];


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/symbol/for.js
// module id = 1002
// module chunks = 0